module.exports = __webpack_public_path__ + "public/img/void-cheque.896b945.svg";